import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import target from "../../assets/target.webp";
import vision from "../../assets/vision.webp";
import { ArrowRight } from "lucide-react";

const Mission = () => {
  const [isMissionsVisible, setIsMissionsVisible] = useState(false);
  const missionsRef = useRef(null);

  const missions = [
    {
      icon: target,
      title: "Our Mission",
      description:
        "To empower businesses with secure, scalable, and innovative IT solutions that drive growth and efficiency.",
    },
    {
      icon: vision,
      title: "Our Vision",
      description:
        "To empower businesses with secure, scalable, and innovative IT solutions that drive growth and efficiency.",
    },
  ];

  // Intersection Observer for animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === missionsRef.current) {
            setIsMissionsVisible(entry.isIntersecting);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (missionsRef.current) {
      observer.observe(missionsRef.current);
    }

    return () => {
      if (missionsRef.current) {
        observer.unobserve(missionsRef.current);
      }
    };
  }, []);

  return (
    <div className="pb-16 mission overflow-hidden">
      <div className="mx-auto">
        <motion.div
          ref={missionsRef}
          initial={{ opacity: 0, y: -50 }}
          animate={{
            opacity: isMissionsVisible ? 1 : 0,
            y: isMissionsVisible ? 0 : -50,
          }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="text-center mb-20"
        >
          <h1 className="text-2xl md:text-6xl font-bold text-white mb-6">
            Redefining IT Solutions in{" "}
            <span className="text-white">Central India</span>
          </h1>
          <p className="text-sm md:text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
            At Multify, we are the pioneers of state-of-the-art data center and
            IT solutions in Chhattisgarh. As the region's first premier data
            center, we combine innovative technology with unmatched customer
            service to help businesses thrive in a rapidly evolving digital
            landscape. Whether you're a startup or an enterprise, we provide
            reliable, secure, and scalable infrastructure to meet your unique
            needs.
          </p>
        </motion.div>

        <div ref={missionsRef} className="grid md:grid-cols-2 gap-8">
          {missions.map((mission, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: index === 0 ? -50 : 50 }}
              animate={{
                opacity: isMissionsVisible ? 1 : 0,
                x: isMissionsVisible ? 0 : index === 0 ? -50 : 50,
              }}
              transition={{
                duration: 0.8,
                ease: "easeOut",
                delay: 0.2 + index * 0.2,
              }}
              className="bg-gradient-to-br from-purple-900/30 to-blue-900/30 rounded-2xl p-8 backdrop-blur-sm"
            >
              <div className="flex flex-col items-center text-center space-y-4">
                <div className="missionImg mb-4">
                  <img
                    src={mission.icon}
                    alt={mission.title}
                    className="w-1/3 mx-auto object-contain"
                  />
                </div>
                <h3 className="text-2xl font-bold text-white">
                  {mission.title}
                </h3>
                <p className="text-gray-300">{mission.description}</p>
                <button className="mt-6 bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-full flex items-center space-x-2 transition-colors duration-300">
                  <span>Learn More</span>
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Mission;
